import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption';
import DesktopAppInstalledComponent from '../../components/DesktopAppInstalledComponent';
import DesktopAppCaptionsModal from '../scribe/DesktopAppCaptionsModal';
import { updateElectronCaptionMode } from '../../actions';
const CCButton = ({ isDesktop, inTwilioCalls, electronCaptionMode, fullScreen, updateElectronCaptionMode }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const [checkIfDesktopAppInstalled, setCheckIfDesktopAppInstalled] = useState(false);
    const [showDesktopAppCaptionPopup, setShowDesktopAppCaptionPopup] = useState(false);
    const openDesktopAppOrShowModal = () => setCheckIfDesktopAppInstalled(true);
    const desktopAppInstalledOrNot = (isInstalled) => {
        setCheckIfDesktopAppInstalled(false);
        // Let's show the desktop app popup only if the app is not installed
        if (!isInstalled) {
            setShowDesktopAppCaptionPopup(true);
        }
    };
    if (isDesktop) {
        return (React.createElement(React.Fragment, null, !electronCaptionMode && !fullScreen && (React.createElement(Fab, { size: "small", style: {
                width: 56,
                height: 56,
                backgroundColor: theme.palette.ava.navy,
                color: theme.palette.ava.white,
            }, onClick: () => updateElectronCaptionMode(true) },
            React.createElement(ClosedCaptionIcon, { style: { fontSize: 36 } })))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Fab, { size: "small", style: {
                width: 56,
                height: 56,
                backgroundColor: theme.palette.ava.navy,
                color: theme.palette.ava.white,
            }, onClick: openDesktopAppOrShowModal },
            React.createElement(ClosedCaptionIcon, { style: { fontSize: 36 } })),
        React.createElement("div", { style: { display: 'none' } },
            checkIfDesktopAppInstalled && (React.createElement(DesktopAppInstalledComponent, { desktopAppInstalledOrNot: desktopAppInstalledOrNot })),
            showDesktopAppCaptionPopup && (React.createElement(DesktopAppCaptionsModal, { onClose: () => setShowDesktopAppCaptionPopup(false), t: t })))));
};
const mapStateToProps = ({ scribeConversation: { inTwilioCalls }, scribeTranscriptUI: { electronCaptionMode, fullScreen }, }) => ({
    inTwilioCalls,
    electronCaptionMode,
    fullScreen,
});
const mapDispatchToProps = { updateElectronCaptionMode };
export default connect(mapStateToProps, mapDispatchToProps)(CCButton);
